/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Suggestions_Welcome_12Inputs */

const es_chat_suggestions_welcome_12 = /** @type {(inputs: Chat_Suggestions_Welcome_12Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Qué tarea o consulta querés resolver hoy, ${i?.name}?`)
};

const en_chat_suggestions_welcome_12 = /** @type {(inputs: Chat_Suggestions_Welcome_12Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`What task or question would you like to address today, ${i?.name}?`)
};

/**
* | output |
* | --- |
* | "What task or question would you like to address today, {name}?" |
*
* @param {Chat_Suggestions_Welcome_12Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_suggestions_welcome_12 = /** @type {((inputs: Chat_Suggestions_Welcome_12Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestions_Welcome_12Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_suggestions_welcome_12(inputs)
	return en_chat_suggestions_welcome_12(inputs)
});
export { chat_suggestions_welcome_12 as "chat.suggestions.welcome_12" }